import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  clearSearch() {
    $('#redirect_rules').DataTable().search('').draw();
    $('.dataTables_filter .close-icon').hide();
  }

  toggleCloseIcon(event) {
    const searchInput = event.target;
    if (searchInput.value.trim() !== '') {
      $('.dataTables_filter .close-icon').show();
    } else {
      $('.dataTables_filter .close-icon').hide();
    }
  }
}
